export const cardStatuses = {
  Active: 'active',
  Blocked: 'blocked',
  Stopped: 'stopped',
  StoppedTemporary: 'stopped-temporary'
};
